export const stripeKey = process.env.VUE_APP_STRIPE_PUBLIC;

export const stripeOptions: any = {
  style: {
    base: {
      color: '#7d7e80',
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: 'antialiased',
      fontSize: '16px',
      fontWeight: 300,
      '::placeholder': {
        color: '#dfdfdf',
      },
    },
    invalid: {
      color: '#9f3a38',
      iconColor: '#9f3a38',
    },
  },
};
